import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Background from './components/Background';
import Header from './components/Header';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import PrivateRoute from './components/PrivateRoute';
import AuthenticatedRoute from './components/AuthenticatedRoute';
import RecoverPassword from './pages/RecoverPassword';
import Modules from './pages/Modules';
import Module from './pages/Module';
import Material from './pages/Material';
import Materials from './pages/Materials';
import NewsList from './pages/NewsList';
import News from './pages/News';
import Community from './pages/Community';
import Unauthorized from './pages/Unauthorized';
import NotFound from './pages/NotFound';
import ApiUnavailable from './pages/ApiUnavailable';
import Seo from './components/Seo';

function RoutesContent() {
    const location = useLocation();
    const isMaterialPage = /^\/material\//.test(location.pathname);
    const showHeader =
        location.pathname !== '/login' &&
        location.pathname !== '/recover-password' &&
        location.pathname !== '/unauthorized' &&
        location.pathname !== '/api-unavailable' &&
        location.pathname !== '/not-found' &&
        !isMaterialPage;

    return (
        <>
            <Seo />
            {showHeader && <Header />}
            
            <Routes>
                <Route element={<PrivateRoute />}>
                    <Route element={<Background />}>
                        <Route path='/' element={ <Dashboard /> } />
                        <Route path='/modules' element={ <Modules /> } />
                        <Route path='/module/:id' element={ <Module /> } />
                        <Route path='/news' element={ <NewsList /> } />
                        <Route path='/news/:id' element={ <News /> } />
                        <Route path='/community' element={ <Community /> } />
                        <Route path='/materials' element={ <Materials /> } />
                        <Route path='/material/:id' element={ <Material /> } />
                    </Route>
                </Route>

                <Route element={<AuthenticatedRoute />}>
                    <Route path='/login' element={ <Login /> } />
                    <Route path='/recover-password' element={ <RecoverPassword /> } />
                </Route>

                <Route path='/unauthorized' element={ <Unauthorized /> } />
                <Route path='/api-unavailable' element={ <ApiUnavailable /> } />
                <Route path='/not-found' element={ <NotFound /> } />
                <Route path='*' element={ <NotFound /> } />
            </Routes>
        </>
    );
}

function RoutesApp() {
    return (
        <BrowserRouter>
            <RoutesContent />
        </BrowserRouter>
    );
}

export default RoutesApp;